import React, { useState } from "react"
import { BsTrash3Fill } from "react-icons/bs"
import { IoAddCircle } from "react-icons/io5"

const EligibleNurseTable = ({ hasWriteSettingsPermission, formData, setFormData, errors }) => {
	const [newNurse, setNewNurse] = useState({ name: "", email: "" })

	const handleNurseAdd = () => {
		if (newNurse.name.trim() === "" || newNurse.email.trim() === "") {
			return
		}
		const updatedNurses = formData.nurses.map(nurse => {
			if (
				nurse.nurseName.toLowerCase() === newNurse.name.toLowerCase() &&
				nurse.nurseEmail.toLowerCase() === newNurse.email.toLowerCase()
			) {
				return { ...nurse, eligibleChargeNurse: true }
			}
			return nurse
		})

		setFormData({ ...formData, nurses: updatedNurses })
		setNewNurse({ name: "", email: "" })
	}

	const handleNurseDelete = nurseId => {
		const updatedNurses = formData.nurses.map(nurse => {
			if (nurse.nurseId.toLowerCase() === nurseId.toLowerCase()) {
				return { ...nurse, eligibleChargeNurse: false }
			}
			return nurse
		})

		setFormData({ ...formData, nurses: updatedNurses })
	}

	if (!formData || !formData.nurses) {
		return <div>No nurses found</div>
	}

	return (
		<div className="mt-10">
			<h2 className="text-2xl font-semibold text-gray-900">Eligible Charge Nurses</h2>

			<div className="overflow-x-auto">
				<div className="max-h-96 overflow-y-auto">
					<table className="min-w-full divide-y divide-gray-200 mt-4 table-auto">
						<thead className="bg-gray-50">
							<tr>
								<th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
									Nurse Name
								</th>
								{hasWriteSettingsPermission && (
									<th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
										Actions
									</th>
								)}
							</tr>
						</thead>
						<tbody className="bg-white divide-y divide-gray-200">
							{formData.nurses
								?.filter(nurse => nurse.eligibleChargeNurse === true)
								.map((nurse, index) => (
									<tr key={nurse.nurseId || index}>
										<td className="px-6 py-4 text-sm text-gray-900 align-middle">
											<span>{nurse.nurseName}</span>
										</td>

										{hasWriteSettingsPermission && (
											<td className="px-6 py-4 text-sm text-gray-900 align-middle">
												<button
													type="button"
													onClick={() => handleNurseDelete(nurse.nurseId)}
													className="py-2 px-4 w-24 bg-red-50 border border-red-200 text-red-600 rounded-lg hover:bg-red-100 flex items-center justify-center gap-2"
												>
													<BsTrash3Fill className="h-4 w-4" />
													Delete
												</button>
											</td>
										)}
									</tr>
								))}

							{hasWriteSettingsPermission && (
								<tr>
									<td className="px-6 py-4 align-top text-sm text-gray-900">
										<select
											value={newNurse.name}
											onChange={e => {
												const selectedNurse = formData.nurses.find(
													nurse =>
														nurse.nurseName === e.target.value &&
														!nurse.eligibleChargeNurse
												)
												setNewNurse({
													name: selectedNurse?.nurseName || "",
													email: selectedNurse?.nurseEmail || ""
												})
											}}
											className="block w-full rounded-md border-gray-300 py-1.5 text-gray-900 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
										>
											<option value="">Select Nurse</option>
											{formData.nurses
												.filter(nurse => !nurse.eligibleChargeNurse) // Only show nurses not eligible yet
												.map(nurse => (
													<option key={nurse.id} value={nurse.nurseName}>
														{nurse.nurseName}
													</option>
												))}
										</select>
										{errors.newNurse?.name && (
											<p className="text-red-600 text-xs mt-1">
												{errors.newNurse.name.message}
											</p>
										)}
									</td>

									<td className="px-6 py-4 text-sm text-gray-900 align-middle">
										<button
											type="button"
											onClick={() => handleNurseAdd()}
											className="py-2 px-4 w-24 bg-green-50 border border-green-200 text-green-600 rounded-lg hover:bg-green-100 flex items-center justify-center gap-2"
										>
											<IoAddCircle className="h-4 w-4" />
											Add
										</button>
									</td>
								</tr>
							)}
						</tbody>
					</table>
				</div>
			</div>
		</div>
	)
}

export default EligibleNurseTable
